var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CFooter',{staticStyle:{"background-color":"#00338e"}},[_c('div',[_c('span',{staticStyle:{"color":"#ffffff"}},[_vm._v("© "+_vm._s(_vm.date)+" ZIEHL-ABEGG SE")])]),_c('div',{staticClass:"ml-auto"})])
}
var staticRenderFns = []

export { render, staticRenderFns }